import React, { Component } from 'react';
import { Pagination, Progress, Form, Input, Button, Table } from 'antd';
import { Select, ConfigProvider, Icon, Popover, Breadcrumb, Tag } from 'antd';
import { Cascader, DatePicker, Checkbox } from 'antd';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import { apis } from '../api/index.js';
import './upload.css';
import moment from 'moment';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';
import { Translation, withTranslation } from 'react-i18next';
import i18n from 'i18next';
import ConnectedMenu from '../connectedComponents/ConnectedMenu.js';
import { getSex, subscribeLocalStorage, formatDA } from '../utils';
import { changeListWidth, getInstitutionOptions } from '../utils';
import { getQCStatus, formatFromTime, formatToTime } from '../utils';
import { getProvinceOption, getAIFilterList, getDay } from '../utils';
import { setScrollTop, institutionRecord, getArea } from '../utils';
import { calcTableHeight, showMoreSearch, fastDateOption } from '../utils';
import { breadItem, breadBack, autoFresh, setSearchInfo } from '../utils';
import { toolTipTitle, timeCalc, loadingOptionsHtml } from '../utils';
import TableEmpty from '../components/TableEmpty.js';
import throttle from 'lodash.throttle';
const { Option } = Select;

let autoRefreshUpload = '';
const initState = {
  page: 1,
  sortBy: '',
  sort: '',
  patName: '',
  defineTimeType: false,
  recentDays: 2,
  institutionId: undefined,
  areaProvince: undefined,
  chestStatus: undefined,
  status: [],
  aistatus: undefined,
  QCStatus: undefined,
  dayRange: [getDay(-2) + ' 0:0:0', getDay(0) + ' 23:59:59'],
  timeTypeVal: false,
  loadingIconShow: false,
  searchLoading: false,
  aihisList: [],
  total: 0,
  i18nextLng: 'zh-CN',
  listWidth: 'calc(87% - 8px)',
  tableScrollW: 0,
};

const high = (
  <span className="red">
    <Icon type="warning" theme="filled" />
    &nbsp;高风险
  </span>
);
const middle = (
  <span className="orange">
    <Icon type="warning" theme="filled" />
    &nbsp;中风险
  </span>
);
const low = (
  <span className="green">
    <Icon type="warning" theme="filled" />
    &nbsp;低风险
  </span>
);
class UploadFrom extends Component {
  static propTypes = {
    form: PropTypes.object,
    server: PropTypes.object,
    setCurrentSearchInfoData: PropTypes.func.isRequired,
    history: PropTypes.object,
    onUserInfoUpdated: PropTypes.func,
    setApplicationData: PropTypes.func,
    match: PropTypes.object,
    location: PropTypes.object,
    userInfo: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.throttledAiHis = throttle(newState => {
      this.getAihis(newState);
    }, 1000);

    this.formResize = throttle(newState => {
      //页面大小改变，更新table高度
      const newHeight = calcTableHeight(189) || 0;
      const showMore = showMoreSearch();
      this.setState({ showMoreFilter: showMore, tableHeight: newHeight });
    }, 1000);
  }

  state = { ...initState };

  componentWillReceiveProps(newProps) {
    if (newProps.match.url !== this.props.match.url) {
      setScrollTop();
      clearInterval(autoRefreshUpload);
      this.setState({ ...initState });
      setTimeout(() => {
        this.pageInit();
        this.props.form.resetFields();
        this.formResize();
      }, 5);
    }
  }

  async componentDidMount() {
    const roleInfo = (this.props.userInfo.operationAuths || '').split(',');
    const isAnonymity = roleInfo.includes('S');

    // 获取省份列表
    const areaList = await getArea(0);
    this.setState({
      isAnonymity,
      roleInfo,
      tableHeight: 0,
      title: '',
      autoRefreshStatus: false,
      moreFilter: true,
      showMoreFilter: false,
      provinceList: areaList,
    });

    this.pageInit();
    this.getDoctorConfigs();
    subscribeLocalStorage(this.throttledAiHis);
    window.addEventListener('resize', () => this.formResize());
    this.formResize();
  }

  pageInit = () => {
    const uploadType = this.props.match.params.id;
    const api = window.store.getState().api;
    //如果是从详情页返回则加载跳转前的列表
    const searchInfo = api.current.searchInfo || {};
    const key = 'upload' + uploadType;
    let state = searchInfo[key] || {};
    state.defineTimeType = state.timeTypeVal;
    let newState = Object.assign({}, initState, state);
    // this.throttledAiHis(newState);

    //从内存中读取是否开启自动刷新
    const autoRefreshStatus = searchInfo.autoRefreshStatus || false;
    newState = {
      ...newState,
      autoRefreshStatus,
      uploadType,
      loadingIconShow: false,
      searchLoading: false,
    };
    this.getInstitutionData('', newState.areaProvince || '');
    this.setState(newState);
    this.reFreshList(autoRefreshStatus);

    //设置页面小标题
    let title = '';
    const titleArray = [
      { value: '1001', name: 'AI报告' },
      { value: '11', name: '肺结核' },
      { value: '6', name: '病毒性肺炎' },
      { value: '8', name: '胸片AI质控' },
      { value: '9', name: '常见肺部疾病' },
    ];
    titleArray.forEach(item => {
      if (item.value === uploadType) title = item.name;
    });
    this.setState({ title });
  };

  //自动刷新列表
  reFreshList = status => {
    this.setState({ autoRefreshStatus: status });
    if (status) {
      autoRefreshUpload = setInterval(() => {
        if (!document.getElementById('uploadForm')) {
          clearInterval(autoRefreshUpload);
        } else {
          const newState = { page: this.state.page };
          this.throttledAiHis(newState);
        }
      }, 10000);
    } else {
      clearInterval(autoRefreshUpload);
    }
  };

  //获取医生审核结果字典
  getDoctorConfigs = () => {
    apis.getDoctorConfigs().then(res => {
      if (res.code === '0') {
        let list = res.data;
        const newList = [
          { id: -1, diseaseName: '全部异常' },
          { id: 0, diseaseName: '待审核' },
        ];
        list = newList.concat(list);
        this.setState({ configList: list });
      } else if (res.code === '1009') this.props.history.push('/login');
    });
  };

  //获取列表
  getAihis = newState => {
    const uploadType = this.props.match.params.id;
    const rows = 20;
    const updatedState = Object.assign({}, this.state, newState);
    this.setState(updatedState);

    let post = {
      institutionId: updatedState.institutionId,
      sortBy: updatedState.sortBy,
      sort: updatedState.sort,
      patName: updatedState.patName,
      areaProvince: updatedState.areaProvince,
      fromTime: undefined,
      toTime: undefined,
    };
    if (updatedState.defineTimeType && updatedState.dayRange) {
      post.fromTime = formatFromTime(updatedState.dayRange);
      post.toTime = formatToTime(updatedState.dayRange);
    } else if (updatedState.recentDays !== undefined) {
      const dayRange = timeCalc(updatedState.recentDays);
      post = { ...post, ...dayRange };
    }
    if (uploadType !== '1001') post.patName = encodeURI(updatedState.patName);

    const aistatus = updatedState.aistatus;
    switch (aistatus) {
      case '1':
        post = { ...post, aiKeyCode: 'abnormal', prefer: '0' };
        break;
      case '2':
        if (uploadType === '11') post.aiKeyCode = 'tuberculosis';
        else if (uploadType === '6') post.aiKeyCode = 'viral_pneumonia';
        else if (uploadType === '9') post.aiKeyCode = 'tuberculosis';
        post.prefer = 1;
        break;
      case '3':
        post = { ...post, aiKeyCode: 'abnormal', prefer: 1 };
        break;
      case '4':
        post = { ...post, aiKeyCode: 'cancer', prefer: 1 };
        break;
      case '5':
        post = { ...post, aiKeyCode: 'pleural_disease', prefer: 1 };
        break;
      case '6':
        post = { ...post, aiKeyCode: 'pneumonia', prefer: 1 };
        break;
      default:
        post = { ...post, aiKeyCode: null, prefer: null };
        break;
    }

    if (uploadType === '1001') {
      if (updatedState.chestStatus === '1') post.chestPa = true;
      else if (updatedState.chestStatus === '0') post.chestPa = false;
      else post.chestPa = null;
    } else if (uploadType === '8') {
      if (updatedState.chestStatus === '1') {
        post = { ...post, aiKeyCode: 'chest_pa', prefer: 1 };
      } else if (updatedState.chestStatus === '0') {
        post = { ...post, aiKeyCode: 'chest_pa', prefer: 0 };
      } else {
        post = { ...post, aiKeyCode: null, prefer: null };
      }
    } else {
      post.chestpa = updatedState.chestStatus;
    }

    if (uploadType === '8') {
      post.doctorResult = '';
      if (updatedState.QCStatus === '1') post.qcpassed = 1;
      else if (updatedState.QCStatus === '2') post.qcpassed = 0;
      else post.qcpassed = null;
    } else {
      if (updatedState.status) {
        if (updatedState.status.length === 2)
          post.doctorResult = updatedState.status[1];
        else if (updatedState.status.length === 1)
          post.doctorResult = updatedState.status[0];
        else post.doctorResult = null;
      }
    }

    let url = '';
    if (uploadType === '1001') {
      post.pageNum = updatedState.page;
      post.pageSize = rows;
      url = apis.aiReportList(post);
    } else if (uploadType === '8') {
      post.offset = (updatedState.page - 1) * rows;
      post.rows = rows;
      post.aiProductType = uploadType;
      url = apis.dicomrecord(post);
    } else {
      post.offset = (updatedState.page - 1) * rows;
      post.rows = rows;
      post.aiProductType = uploadType;
      url = apis.studyRecord(post);
    }

    url.then(result => {
      //
      this.setState({ loadingIconShow: false, searchLoading: false });
      if (result.code === '0') {
        let aihisList = result.data.list;
        if (uploadType === '8') aihisList = this.formatAIResult(aihisList);
        this.setState({ aihisList: aihisList, total: result.data.total });
      } else {
        if (result.code === '1009') this.props.history.push('/login');
        this.setState({ aihisList: [], total: 0 });
      }
    });
  };

  //查看详情
  viewHeatmap = item => {
    const uploadType = this.props.match.params.id;

    const w = window.screen.width - 10;
    const h = window.screen.height - 105;

    const study_uid = item.studyUid;
    const series_uid = item.seriesUid;
    const sop_instance_uid = item.sopInstanceId;
    const id = item.id;
    let url = '';

    const isOtherBody =
      item.chestPa !== 1 && item.chestPa !== true ? true : false;
    if (uploadType === '1001') {
      const info = {
        patName: item.patName,
        patSex: item.patSex,
        patAge: item.patAge,
        studyUid: item.studyUid,
        subVos: [
          {
            selectFlag: true,
            seriesUid: item.seriesUid,
            sopInstanceId: item.sopInstanceId,
          },
        ],
      };
      this.props.setApplicationData(info);

      url = `/viewer/study/${study_uid}?from=report&dicomId=${item.dicomDrId}&from1=aireport&isOtherBody=${isOtherBody}`;
    } else if (uploadType === '8') {
      this.props.setApplicationData(item);
      url = `/heatmap?objects=[{"StudyUid":"${study_uid}","SeriesUid":"${series_uid}","ObjectUid":"${sop_instance_uid}"}]&type=${this.state.uploadType}&id=${id}&isOtherBody=${isOtherBody}&from=aiqc`;
    } else {
      const info = {
        patName: item.patName,
        patSex: item.patSex,
        patAge: item.patAge,
        studyUid: item.studyUid,
      };
      this.props.setApplicationData(info);
      url = `/viewer/study/${study_uid}?from=aiproduct&id=${item.id}&type=${uploadType}`;
    }
    const str = `scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes,width=${w},height=${h}`;
    window.open(url, 'viewer', str);
  };

  //点击搜索按钮
  handleSearch = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const newState = {
          institutionId: (values.name || []).join(','),
          patName: values.patName,
          page: 1,
          loadingIconShow: true,
          searchLoading: true,
          areaProvince: values.provice,
          aistatus: values.aistatus,
          chestStatus: values.chestStatus,
          status: values.status,
          QCStatus: values.QCStatus,
          dayRange: values.dayRange, //起止时间
          recentDays: values.recentDays, //用天数计算起止时间
          defineTimeType: this.state.timeTypeVal,
          timeTypeVal: this.state.timeTypeVal,
        };
        this.throttledAiHis(newState);

        const uploadType = this.props.match.params.id;
        setSearchInfo(newState, 'upload' + uploadType, this);
        setScrollTop();
      }
    });
  };

  //点击重置按钮
  handleReset = () => {
    const loadingState = { searchLoading: true };
    //
    const newState = Object.assign({}, initState, loadingState);
    setScrollTop();
    this.setState(newState);
    this.props.form.resetFields();
    this.getInstitutionData();
    this.throttledAiHis(newState);
    //重置搜索缓存
    const uploadType = this.props.match.params.id;
    setSearchInfo(initState, 'upload' + uploadType, this);
  };

  getDoctorResult = code => {
    let color = '';
    //根据code值确定tag的颜色
    switch (code) {
      case '待审核':
        color = '#F4A237';
        break;
      case '影像阴性':
        color = '#87D067';
        break;
      case '影像阳性':
        color = '#FF5605';
        break;
      case '未开通审核':
      case '无需审核':
      case '未审核':
        color = '#999999';
        break;
      default:
        color = '#FF5605';
        break;
    }
    let tagHtml = <Tag color={color}>{code}</Tag>;
    return tagHtml;
  };
  handleChangeSelect = (id, value) => {
    const newData = [...this.state.aihisList];
    const index = newData.findIndex(item => id === item.id);
    if (index > -1) {
      const changedData = newData[index];
      changedData.part = value;
      newData[index] = changedData;
      this.setState({ aihisList: newData });
    }
  };
  //获取是否是正位胸片
  getChestPa = (code, list) => {
    const uploadType = this.props.match.params.id;
    const chestPa = <span className="text-tag-chestpa">正位胸片</span>;
    const other = <span className="text-tag-other">其他部位</span>;
    if (uploadType === '1001') {
      return <>{code ? chestPa : other}</>;
    } else if (uploadType === '8') {
      return (
        <>
          {code === 0 && <span className="text-tag-unknown">未知</span>}
          {code === 1 && chestPa}
          {code === 2 && other}
        </>
      );
    } else {
      if (code === '0') {
        //其他部位
        return other;
      } else if (code === '1') {
        //正位胸片+其他部位
        return (
          <Select
            style={{ width: 90 }}
            size="small"
            value={list.part || 'chestPa'}
            onChange={this.handleChangeSelect.bind(this, list.id)}
          >
            <Option key={0} value="chestPa">
              正位胸片
            </Option>
            <Option key={1} value="other">
              其他部位
            </Option>
          </Select>
        );
      } else if (code === '2') {
        //正位胸片
        return chestPa;
      } else {
        return <span>--</span>;
      }
    }
  };

  //分页
  pageOnChange = (page, pageSize) => {
    setScrollTop();
    const newState = { page, searchLoading: true };
    this.throttledAiHis(newState);
  };

  //获取机构列表
  getInstitutionData = async (name, area) => {
    const data = await institutionRecord(name, area);
    this.setState({ institutionData: data });
  };

  //机构下拉的查询功能
  handleInstitutionSearch = value => {
    const area = this.state.areaProvince;
    this.getInstitutionData(value, area);
  };

  //格式化ai结果中的值
  formatAIResult = aihisList => {
    for (var i in aihisList) {
      let chestPa = 0;
      aihisList[i].aiResult = aihisList[i].aiResult || [];
      aihisList[i].aiResult.forEach(item => {
        if (item.keyCode === 'chest_pa')
          chestPa = item.confidence > 0.5 ? 1 : 2;
      });

      aihisList[i].doctorResult[0] = aihisList[i].doctorResult[0] || {};
      aihisList[i].chestPa = chestPa;
    }
    return aihisList;
  };

  //获取质控详细内容
  getQCResult = (reason, passed, chestPa) => {
    const result = [];
    if (chestPa !== 1) {
      return <p>{i18n.t('unKnown')}</p>;
    } else if (passed) {
      result.push(<span>{i18n.t('qualified')}</span>);
    } else {
      reason = JSON.parse(reason);
      for (let i in reason) {
        result.push(<span className="group-name">{i}</span>);
        const content = reason[i].split(',');
        content.forEach(item => {
          result.push(<span className="group-content">{item}</span>);
        });
      }
    }
    return (
      <div>
        {result.map((item, index) => {
          return <p key={index}>{item}</p>;
        })}
      </div>
    );
  };

  //获取ai疾病状态
  getAIDieaseStatus = result => {
    let tagHtml = <Tag color="#A6A6A6">{i18n.t('unKnown')}</Tag>;
    if (result.isContainsChestPa === '0') return tagHtml;

    let flag = false;
    if (result.abnormalConfidence9 > 0.5) flag = true;
    else if (result.tuberculosisConfidence9 > 0.5) flag = true;
    const abnormal = <Tag color="#f50">{i18n.t('abnormal1')}</Tag>;
    const normal = <Tag color="#77c565">{i18n.t('normal')}</Tag>;
    tagHtml = flag ? abnormal : normal;
    return tagHtml;
  };

  //获取AI诊断状态标签
  getAIResult = value => {
    if (typeof value === 'number') {
      if (value >= 0.5) return <Tag color="#FF5605">异常</Tag>;
      else if (value < 0.5) return <Tag color="#87D067">正常</Tag>;
    } else {
      return <Tag color="#A6A6A6">未知</Tag>;
    }
  };

  //获取ai疾病详细内容
  getAIDieaseResult = result => {
    let resultHtml = [];
    if (result.isContainsChestPa === '0') {
      resultHtml.push(<p key={999}>未知</p>);
      return resultHtml;
    }
    for (let i in result) {
      if (i === 'tuberculosisConfidence9') {
        resultHtml.push(
          <p key={i}>肺结核{(parseFloat(result[i] || 0) * 100).toFixed(0)}</p>
        );
      }
      if (i === 'cancerConfidence9')
        resultHtml.push(<p key={i}>结节肿块{(result[i] * 100).toFixed(0)}</p>);

      if (i === 'pneumoniaConfidence9')
        resultHtml.push(<p key={i}>肺炎{(result[i] * 100).toFixed(0)}</p>);

      if (i === 'pleuralDiseaseConfidence9')
        resultHtml.push(<p key={i}>胸膜胸腔{(result[i] * 100).toFixed(0)}</p>);
    }
    return resultHtml;
  };

  getReviewedStatusDetail = (name, content) => {
    const contentHtml = <div className="popover-width">{content}</div>;
    if (content) {
      return (
        <Popover
          placement="bottomLeft"
          content={contentHtml}
          title={i18n.t('impressionR')}
        >
          {this.getDoctorResult(name)}
        </Popover>
      );
    } else {
      return <span>{this.getDoctorResult(name || '未开通')}</span>;
    }
  };

  getLevel = item => {
    const value = Math.round(item.viralPneumoniaConfidence6 * 100);
    const detail = item.reviewedStatusDetail || '';
    const name = item.reviewedStatusName;

    const array = ['待审核', '影像阳性', '无需审核', '影像阴性', '未审核'];
    if (detail.includes('疑似病毒性肺炎')) return high;
    else if (array.includes(name)) return value > 50 ? middle : low;
    else return '--';
  };

  getColumns = () => {
    const uploadType = this.props.match.params.id;
    const { sortBy, sort, isAnonymity, roleInfo = [] } = this.state;
    const columns = [];
    let tableWidth = document.body.clientWidth * 0.87 - 50;
    let isBig = tableWidth > 1420;
    let tableScrollW = isBig ? 440 : 330;
    columns.push(
      {
        title: '姓名',
        dataIndex: 'patName',
        key: 'patName',
        width: isBig ? 200 : 170,
        render: patName => (isAnonymity ? '***' : patName),
      },
      {
        title: '年龄',
        dataIndex: 'patAge',
        key: 'patAge',
        width: isBig ? 120 : 80,
        render: patAge => (isAnonymity ? '***' : patAge),
      },
      {
        title: '性别',
        dataIndex: 'patSex',
        key: 'patSex',
        width: isBig ? 120 : 80,
        render: patSex => (isAnonymity ? '***' : getSex(patSex)),
      }
    );
    if (['8', '1001'].includes(uploadType)) {
      const width = isBig ? 160 : 120;
      tableScrollW += width;
      columns.push({
        title: i18n.t('bodyPart'), //部位
        dataIndex: 'chestPa',
        key: 'chestPa',
        width,
        render: value => <>{this.getChestPa(value)}</>,
      });
    } else {
      const width = isBig ? 160 : 120;
      tableScrollW += width;
      columns.push({
        title: i18n.t('bodyPart'), //部位
        key: 'isContainsChestPa',
        width,
        render: list => <>{this.getChestPa(list.isContainsChestPa, list)}</>,
      });
    }
    if (uploadType === '6') {
      tableScrollW += 180;
      columns.push({
        title: i18n.t('suspectedViralPneumonia'), //疑似病毒性肺炎
        key: 'viralPneumoniaConfidence6',
        width: 180,
        render: record => {
          const chestPa = record.isContainsChestPa;
          if (chestPa === '0' || record.part === 'other')
            return <span>--</span>;
          return <div className="warning">{this.getLevel(record)}</div>;
        },
      });
    }
    if (['9', '11'].includes(uploadType)) {
      tableScrollW += 180;
      columns.push({
        title: (
          <span>
            {i18n.t('abnormal')}&nbsp;
            {toolTipTitle('AI诊断疾病的整体异常疑似度', 'topLeft')}
          </span>
        ), //异常疑似度
        key: 'abnormal',
        sorter: true,
        sortDirections: ['ascend', 'descend'],
        defaultSortOrder: sortBy === 'abnormal' ? sort : '',
        width: 180,
        render: r => {
          let chestPa = r.isContainsChestPa;
          if (chestPa === '0' || r.part === 'other') return <span>--</span>;

          let abnormal =
            uploadType === '9' ? r.abnormalConfidence9 : r.abnormalConfidence11;
          abnormal = parseFloat(((abnormal || 0) * 100).toFixed(1));

          return (
            <Progress
              strokeColor={abnormal < 50 ? '#2F7BFF' : '#DC2F2F'}
              percent={abnormal}
              status="active"
              strokeWidth={5}
              style={{ width: 50 }}
            />
          );
        },
      });
    }
    if (uploadType === '9') {
      tableScrollW += 120;
      columns.push({
        title: i18n.t('AIDiseaseDiagnosis'), //AI疾病诊断
        key: 'qcResult',
        width: 120,
        render: list => {
          if (list.part === 'other') return <span>--</span>;
          return (
            <Popover
              placement="bottomLeft"
              content={this.getAIDieaseResult(list)}
              title={i18n.t('impressionR')}
            >
              {this.getAIDieaseStatus(list)}
            </Popover>
          );
        },
      });
    }

    if (uploadType === '11') {
      tableScrollW += 180;
      columns.push({
        title: 'AI肺结核诊断', //AI肺结核诊断
        key: 'tuberculosis',
        width: 180,
        sorter: true,
        sortDirections: ['ascend', 'descend'],
        defaultSortOrder: sortBy === 'tuberculosis' ? sort : '',
        render: list => {
          const chestPa = list.isContainsChestPa;
          if (chestPa === '0' || list.part === 'other') return <span>--</span>;

          let value = list.tuberculosisConfidence11 || 0;
          value = parseFloat((value * 100).toFixed(1));
          return (
            <Progress
              strokeColor={value < 50 ? '#2F7BFF' : '#DC2F2F'}
              percent={value}
              status="active"
              strokeWidth={5}
              style={{ width: 50 }}
            />
          );
        },
      });
    }
    if (['6', '9', '11'].includes(uploadType)) {
      tableScrollW += 120;
      if (roleInfo.includes('E')) {
        columns.push({
          title: i18n.t('radiologistReview'), //医生审核
          key: 'resultCode',
          width: 120,
          render: list => (
            <>
              {this.getReviewedStatusDetail(
                list.reviewedStatusName,
                list.reviewedStatusDetail
              )}
            </>
          ),
        });
      }
    }
    if (uploadType === '8') {
      const width = isBig ? 300 : 220;
      tableScrollW += width;
      columns.push({
        title: i18n.t('QCStatus'), //质控结果
        key: 'qcResult',
        width,
        render: list => (
          <Popover
            placement="bottomLeft"
            content={this.getQCResult(
              list.qcUnpassedReason,
              list.qcpassed,
              list.chestPa
            )}
            title={i18n.t('QCResult')}
          >
            {getQCStatus(list.qcpassed, list.chestPa)}
          </Popover>
        ),
      });
    }
    if (uploadType === '1001') {
      const width = isBig ? 220 : 180;
      tableScrollW += width;
      tableScrollW += 240;
      columns.push(
        {
          title: '置信度',
          key: 'score',
          width,
          render: record => {
            const chestPa = record.chestPa;
            if (!chestPa) return <span>--</span>;
            let value = record.score || 0;
            value = parseFloat((value * 100).toFixed(1));
            return (
              <Progress
                strokeColor={value < 50 ? '#2F7BFF' : '#DC2F2F'}
                percent={value}
                status="active"
                strokeWidth={5}
                style={{ width: 50 }}
              />
            );
          },
        },
        {
          title: 'AI诊断',
          dataIndex: 'abnormal',
          key: 'abnormal',
          width: 120,
          render: value => <>{this.getAIResult(value)}</>,
        },
        {
          title: '医生审核',
          dataIndex: 'reviewedStatusName',
          key: 'reviewedStatusName',
          width: 120,
          render: value => <>{this.getDoctorResult(value)}</>,
        }
      );
    }
    tableScrollW += 510;
    columns.push(
      {
        title: i18n.t('uploadTime'), //上传时间
        dataIndex: uploadType === '1001' ? 'studyTime' : 'createTime',
        key: 'createTime',
        width: 180,
        render: createTime => <>{formatDA(createTime)}</>,
      },
      {
        title: i18n.t('institution'), //机构
        dataIndex: 'institutionName',
        key: 'institutionName',
        render: institutionName => <>{isAnonymity ? '***' : institutionName}</>,
      },
      {
        title: i18n.t('operation'), //操作
        key: 'id',
        align: 'center',
        width: 150,
        fixed: 'right',
        render: list => (
          <Button
            type="link"
            className="btn-viewdetail"
            onClick={() => this.viewHeatmap(list)}
          >
            <Icon type="eye" theme="filled" />
            {i18n.t('detailedInfo')}
          </Button>
        ),
      }
    );
    return [columns, tableScrollW];
  };

  handleChangeProvince = value => {
    this.setState({ areaProvince: value });
    this.getInstitutionData('', value);
  };

  setTimeType = e => {
    this.setState({ timeTypeVal: e.target.checked });
  };
  setFreshEvent = e => {
    // if (e.target.checked) this.setSearchEvent('ns-062');
    // else this.setSearchEvent('ns-063');
  };
  setBackEvent = () => {
    // this.setSearchEvent('ns-066');
  };
  render() {
    const uploadType = this.props.match.params.id;
    let { title, configList, institutionData, isAnonymity } = this.state;
    let { areaProvince, institutionId, aihisList, timeTypeVal } = this.state;
    let { patName, chestStatus, status, QCStatus } = this.state;
    let { aistatus, tableHeight, recentDays, dayRange } = this.state;
    let { moreFilter, showMoreFilter, searchLoading } = this.state;
    let { loadingIconShow, roleInfo = [] } = this.state;
    institutionId = institutionId ? institutionId.split(',') : [];
    institutionId = institutionId.map(item => +item);

    const { RangePicker } = DatePicker;
    const dateFormat = 'YYYY-MM-DD';

    const [columns, tableScrollW] = this.getColumns();

    const { getFieldDecorator } = this.props.form;

    const screenWidth = document.body.clientWidth * 0.87 - 55;
    let tableWidth = screenWidth > tableScrollW ? screenWidth : tableScrollW;

    const loadingOptions = loadingOptionsHtml(searchLoading);

    const from = formatFromTime(dayRange);
    const to = formatToTime(dayRange);
    return (
      <Translation>
        {t => (
          <div className="form-bg" id="uploadForm">
            <ConnectedMenu toggleCollapsed={changeListWidth.bind(this, this)} />
            <div className="theme-content">
              <ConnectedHeader
                toggleCollapsed={changeListWidth.bind(this, this)}
                login={false}
                home={true}
              />
              <div className="theme-box">
                <div className="bread-crumb">
                  <Breadcrumb>{breadItem(['AI应用', t(title)])}</Breadcrumb>
                  {breadBack(this)}
                  {autoFresh(this)}
                </div>
                <div className="box" style={{ width: this.state.listWidth }}>
                  <div className="left">
                    <Form
                      className={`ant-advanced-search-form${
                        !moreFilter && showMoreFilter ? ' notOverflow' : ''
                      }`}
                      onSubmit={this.handleSearch}
                      layout="inline"
                    >
                      <div className="searchBox">
                        <div className="searchBoxContent">
                          <div className="search-unit">
                            <Form.Item
                              style={{
                                display: timeTypeVal === true ? '' : 'none',
                              }}
                              label={t('uploadTime')}
                              colon={false}
                            >
                              <ConfigProvider locale={zh_CN}>
                                {getFieldDecorator('dayRange', {
                                  initialValue:
                                    from && to
                                      ? [
                                          moment(from, dateFormat),
                                          moment(to, dateFormat),
                                        ]
                                      : null,
                                })(
                                  <RangePicker
                                    format={dateFormat}
                                    placeholder={[t('startDate'), t('endDate')]}
                                    style={{ width: 240 }}
                                  />
                                )}
                              </ConfigProvider>
                            </Form.Item>
                            <Form.Item
                              style={{
                                display: timeTypeVal === true ? 'none' : '',
                              }}
                              label={t('uploadTime')}
                              colon={false}
                            >
                              {getFieldDecorator('recentDays', {
                                initialValue: recentDays,
                              })(
                                <Select
                                  defaultActiveFirstOption={true}
                                  filterOption={false}
                                  allowClear={true}
                                  style={{ width: 240 }}
                                >
                                  {fastDateOption()}
                                </Select>
                              )}
                            </Form.Item>
                            <Form.Item label="" colon={false}>
                              {getFieldDecorator('defineTimeType', {})(
                                <Checkbox
                                  checked={timeTypeVal}
                                  onChange={this.setTimeType}
                                >
                                  自定义
                                </Checkbox>
                              )}
                            </Form.Item>
                          </div>
                          <div className="search-unit">
                            <Form.Item
                              label="机构"
                              colon={false}
                              className="form-provice"
                            >
                              {getFieldDecorator('provice', {
                                initialValue: areaProvince,
                              })(
                                <Select
                                  showSearch
                                  placeholder="选择省份"
                                  style={{ width: 150 }}
                                  defaultActiveFirstOption={false}
                                  filterOption={false}
                                  onChange={this.handleChangeProvince}
                                  notFoundContent={null}
                                  allowClear={true}
                                  disabled={isAnonymity}
                                >
                                  {getProvinceOption(this.state.provinceList)}
                                </Select>
                              )}
                            </Form.Item>
                            <Form.Item
                              label=""
                              colon={false}
                              className="form-institute"
                            >
                              {getFieldDecorator('name', {
                                initialValue: institutionId,
                              })(
                                <Select
                                  className="institution-selection"
                                  showSearch
                                  mode="multiple"
                                  placeholder="请选择机构"
                                  defaultActiveFirstOption={false}
                                  filterOption={false}
                                  onSearch={this.handleInstitutionSearch}
                                  allowClear={true}
                                  style={{ width: 220 }}
                                  disabled={isAnonymity}
                                >
                                  {getInstitutionOptions(institutionData, 'id')}
                                </Select>
                              )}
                            </Form.Item>
                          </div>
                          <Form.Item label={t('bodyPart')} colon={false}>
                            {getFieldDecorator('chestStatus', {
                              initialValue: chestStatus,
                            })(
                              <Select
                                style={{ width: 160 }}
                                allowClear={true}
                                placeholder={t('selectPart')}
                              >
                                <Option value="1">{t('chestPA')}</Option>
                                <Option value="0">{t('otherBodyPart')}</Option>
                              </Select>
                            )}
                          </Form.Item>
                          <Form.Item label={t('name')} colon={false}>
                            {getFieldDecorator('patName', {
                              initialValue: patName,
                            })(
                              <Input
                                style={{ width: 160 }}
                                allowClear={true}
                                placeholder={t('enterSubjectName')}
                                disabled={isAnonymity}
                              />
                            )}
                          </Form.Item>
                          {uploadType === '8' && (
                            <Form.Item label={t('QCStatus')} colon={false}>
                              {getFieldDecorator('QCStatus', {
                                initialValue: QCStatus,
                              })(
                                <Select
                                  style={{ width: 160 }}
                                  allowClear={true}
                                  placeholder={t('QCStatus')}
                                >
                                  <Option value="1">{t('qualified')}</Option>
                                  <Option value="2">{t('unqualified')}</Option>
                                </Select>
                              )}
                            </Form.Item>
                          )}
                          {uploadType !== '8' && (
                            <>
                              {roleInfo.includes('E') && (
                                <Form.Item label="医生审核状态" colon={false}>
                                  {getFieldDecorator('status', {
                                    initialValue: status,
                                  })(
                                    <Cascader
                                      fieldNames={{
                                        label: 'diseaseName',
                                        value: 'id',
                                        children: 'childs',
                                      }}
                                      options={configList}
                                      placeholder={i18n.t('selectStatus')}
                                      allowClear={true}
                                      style={{ width: 200 }}
                                    />
                                  )}
                                </Form.Item>
                              )}

                              <Form.Item label="AI疾病诊断状态" colon={false}>
                                {getFieldDecorator('aistatus', {
                                  initialValue: aistatus,
                                })(
                                  <Select
                                    placeholder="AI疾病诊断状态"
                                    allowClear={true}
                                    style={{ width: 200 }}
                                  >
                                    {getAIFilterList(uploadType)}
                                  </Select>
                                )}
                              </Form.Item>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="searchOptBox">
                        <Form.Item>
                          <Button
                            type="primary"
                            htmlType="submit"
                            className="btn-search"
                            disabled={searchLoading}
                          >
                            {loadingIconShow ? (
                              <Icon type="sync" spin />
                            ) : (
                              <Icon type="search" />
                            )}
                            {t('search')}
                          </Button>
                          <Button
                            style={{ marginLeft: 8 }}
                            icon="redo"
                            className="btn-reset"
                            onClick={this.handleReset}
                            disabled={searchLoading}
                          >
                            {t('reset')}
                          </Button>
                        </Form.Item>
                        {showMoreFilter && (
                          <Button
                            type="link"
                            className="moreFilter"
                            onClick={() =>
                              this.setState({ moreFilter: !moreFilter })
                            }
                            icon={moreFilter ? 'down' : 'up'}
                          >
                            {moreFilter ? '展开' : '收起'}
                          </Button>
                        )}
                      </div>
                    </Form>
                    <div className="history-list">
                      <Table
                        loading={loadingOptions}
                        columns={columns}
                        dataSource={aihisList}
                        rowKey={(record, index) => index}
                        pagination={false}
                        className="list-item"
                        scroll={{ x: tableWidth, y: tableHeight }}
                        locale={{ emptyText: <TableEmpty /> }}
                        onChange={(pagination, filters, sorter) => {
                          const orderType = { descend: 'DESC', ascend: 'ESC' };
                          const sortType = orderType[sorter.order];
                          const orderField = sorter.columnKey || '';
                          const newState = {
                            page: 1,
                            sortBy: orderField,
                            sort: sortType,
                            searchLoading: true,
                          };
                          this.throttledAiHis(newState);
                        }}
                      />
                      <ConfigProvider locale={zh_CN}>
                        <Pagination
                          onChange={this.pageOnChange}
                          total={this.state.total}
                          pageSize={20}
                          className="list-page"
                          current={this.state.page}
                          showQuickJumper
                          size="small"
                          showTotal={() => `共${this.state.total}条`}
                        ></Pagination>
                      </ConfigProvider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

export default withRouter(Form.create()(withTranslation('Common')(UploadFrom)));
